// JustSmash sends no analytics anywhere. Its client started as a copy of Royal
// Smash and kept reporting into Royal Smash's pipeline: the same analytics
// WebSocket (session start/heartbeat/impressions/events), app name
// "royalsmash", S2S events and AppsFlyer — mixing its players into Royal
// Smash's numbers. Every sender checks this flag; flip it only together with a
// JustSmash-owned pipeline.
export const ANALYTICS_OFF = true;
